import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import {InnerHtml} from '@rambler-id/react-utils'
import {copy} from '@rambler-id/dom'
import {Snackbar as RuiSnackbar} from 'rambler-ui'
import styles from './styles.css'

export default class Snackbar extends PureComponent {
  static propTypes = {
    type: PropTypes.string,
    autoCloseDuration: PropTypes.number,
    copyable: PropTypes.bool,
    message: PropTypes.string.isRequired
  }

  state = {
    copied: false
  }

  copyErrorMessage = async (message) => {
    try {
      await copy(message)
      this.setState({copied: true})
    } catch (error) {} // eslint-disable-line no-empty
  }

  render() {
    const {type, autoCloseDuration, message, copyable, ...props} = this.props
    const {copied} = this.state

    return (
      <RuiSnackbar
        type={type}
        positionY="top"
        showClose
        autoCloseDuration={autoCloseDuration}
        {...props}>
        <InnerHtml className={copyable ? styles.errorMessage : ''}>
          {message}
        </InnerHtml>
        {copyable && (
          <React.Fragment>
            {copied ? (
              <React.Fragment>
                Ошибка скопирована!{' '}
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={'https://help.rambler.ru/feedback/id/'}
                  className={styles.errorButton}>
                  Написать в службу поддержки
                </a>
              </React.Fragment>
            ) : (
              <button
                className={styles.errorButton}
                onClick={() => this.copyErrorMessage(message)}>
                Скопировать информацию об ошибке
              </button>
            )}
          </React.Fragment>
        )}
      </RuiSnackbar>
    )
  }
}
